import AppModel from '@/models/AppModel'
import store from '@/store/model-store'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  apiSetStore: (bvModal, params, callback) => {
    return AppModel.delete('estimate', bvModal, params, (res) => {
      if (isDebug) {
        console.log(res.data)
      }

      AppModel.validateStatus(res.data)

      let modelStore = store.getters.model
      if (!modelStore) {
        modelStore = {}
      }
      if (modelStore['otherEstimate'] && modelStore['otherEstimate']['imageAndMemo']) {
        if ('mainGuestType' in params) {
          delete modelStore['otherEstimate']['imageAndMemo'][params['mainGuestType']]
        } else {
          delete modelStore['otherEstimate']['imageAndMemo'][params['projectType']]
        }
      }
      modelStore['estimateDelete'] = res.data
      store.commit('setModel', modelStore)

      return Promise.resolve(res.data)
    }, null, callback)
  },
  getStore: (key) => {
    return AppModel.getStore('estimateDelete', key)
  },
  removeStore: () => {
    delete store.getters.model.sign
  }
}
